import { AxiosRequest } from "../common/axios-request";
import {
  CREATE_COURT,
  DELETE_COURT,
  DELETE_COURT_RATES,
  GET_ALL_COURT_LIST,
  GET_AVAILABLE_COURT_FOR_SESSION,
  GET_COURTS_AVAILABLE_FOR_ASSOCIATE_BOOKING,
  GET_COURT_DETAILS,
  GET_COURT_FOR_FACILITY_SPORT,
  GET_SLOTS_BY_SPORT,
  GET_SLOTS_FOR_ASSOCIATE_BOOKING,
  GET_SLOTS_OF_COURT,
  UPDATE_COURT,
} from "../common/constant";

const GetCourtList = (facilityId: string, sportId: string = "") => {
  return AxiosRequest.get(GET_ALL_COURT_LIST(facilityId, sportId));
};

const GetCourtsDetail = (id: string) => {
  return AxiosRequest.get(GET_COURT_DETAILS.replace(":id", id));
};

const CreateCourt = (payload: any) => {
  return AxiosRequest.post(CREATE_COURT, payload);
};

const UpdateCourts = (id: string, payload: any) => {
  return AxiosRequest.put(UPDATE_COURT.replace(":id", id), payload);
};

const DeleteCourt = (id: string) => {
  return AxiosRequest.delete(DELETE_COURT.replace(":id", id));
};

const DeleteCourtRate = (id: string, rate: string) => {
  return AxiosRequest.delete(
    DELETE_COURT_RATES.replace(":id", id).replace(":rate", rate)
  );
};

const GetFilterdCourt = (fId: string, sId: string, isActive: string = "") => {
  return AxiosRequest.get(GET_COURT_FOR_FACILITY_SPORT(fId, sId, isActive));
};

const GetSlotsOfCourt = (id: string, date: string) => {
  return AxiosRequest.get(GET_SLOTS_OF_COURT(id, date));
};

const GetAvailableCourtForSession = (payload: any) => {
  return AxiosRequest.post(GET_AVAILABLE_COURT_FOR_SESSION, payload);
};

const GetSlotsForAssociateBooking = (
  startDate: string,
  endDate: string,
  facilityId: string = "",
  sportId: string = ""
) => {
  return AxiosRequest.get(
    GET_SLOTS_FOR_ASSOCIATE_BOOKING(startDate, endDate, facilityId, sportId)
  );
};

const GetCourtsAvailableForAssociateBooking = (payload: any) => {
  return AxiosRequest.post(GET_COURTS_AVAILABLE_FOR_ASSOCIATE_BOOKING, payload);
};

const GetSlotsBySport = (facilityId: string, sportId: string, date: string, courtId: string) => {
  return AxiosRequest.get(GET_SLOTS_BY_SPORT(facilityId, sportId, date, courtId));
};

export {
  GetCourtList,
  GetCourtsDetail,
  CreateCourt,
  UpdateCourts,
  DeleteCourt,
  DeleteCourtRate,
  GetFilterdCourt,
  GetSlotsOfCourt,
  GetAvailableCourtForSession,
  GetSlotsForAssociateBooking,
  GetCourtsAvailableForAssociateBooking,
  GetSlotsBySport,
};
